import { type RouteRecordRaw } from 'vue-router'

import { useAdsStore } from './ads.store'

export const AdsRouter: RouteRecordRaw[] = [
  {
    path: '/ads',
    component: async () => import('./ads.vue'),
    async beforeEnter() {
      await useAdsStore.getState().loadApplicationCfg()
    },
  },
]
